import React from 'react';
import { motion } from 'framer-motion';
import { Navigation } from './Navigation';
import { Toaster } from 'react-hot-toast';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-[var(--background)] p-4 md:p-6">
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: 'rgba(16, 20, 24, 0.8)',
            color: '#f8fafc',
            border: '1px solid rgba(39, 245, 131, 0.1)',
            backdropFilter: 'blur(12px)',
          },
        }}
      />
      <div className="max-w-7xl mx-auto">
        <Navigation />
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
          className="space-y-4 md:space-y-6"
        >
          {children}
        </motion.div>
      </div>
    </div>
  );
};